import { PaymentReportPage } from './PaymentReportPage'
import { withPaymentReportPage } from './withPaymentReportPage'

const ConnectedPaymentReportPage = withPaymentReportPage(PaymentReportPage)

export { ConnectedPaymentReportPage as PaymentReportPage }
